export interface AdminUserInfo {
  id: string;
  email: string;
  full_name: string;
  admin_role: string;
  admin_2fa_enabled: boolean;
  admin_2fa_setup_deadline: string | null;
}

export interface AdminLoginRequest {
  email: string;
  password: string;
}

export interface AdminLoginResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  admin_user: AdminUserInfo;
}

export interface Admin2FARequiredResponse {
  requires_2fa: true;
  temp_token: string;
}

export interface Admin2FAVerifyRequest {
  temp_token: string;
  code: string;
}

export interface Admin2FASetupResponse {
  secret: string;
  qr_code: string;
  provisioning_uri: string;
  backup_codes: string[];
}

export interface Admin2FASetupConfirmRequest {
  code: string;
}

export interface AdminSessionInfo {
  id: string;
  ip_address: string | null;
  user_agent: string | null;
  location: string | null;
  expires_at: string;
  last_activity_at: string | null;
  created_at: string;
  is_current: boolean;
}

export interface AdminSessionListResponse {
  sessions: AdminSessionInfo[];
  total: number;
}

export type LoginResult = AdminLoginResponse | Admin2FARequiredResponse;

export function isLoginSuccess(result: LoginResult): result is AdminLoginResponse {
  return 'access_token' in result;
}

export function is2FARequired(result: LoginResult): result is Admin2FARequiredResponse {
  return 'requires_2fa' in result && result.requires_2fa;
}
